import { useLazyQuery } from "@apollo/client";
import Cookies from "js-cookie";
import moment from "moment";
import { GET_TOTAL_TRADES } from "../../graphql/liveQuery/queries";
import { toTitleCase } from "./normalize";

export type AdviceType = "FNO" | "LFT" | "EQ" | "EqN50plus" | "OPT LONG" | "EqBANK" | "EQIT";
export type ActiveTab = "Live" | "Executed";

export interface TslObject {
  time: string,
  target?: number,
  stoploss?: number,
};


export const displayAmount:any = [
  { name: '₹ 1Cr',value: 10000000 },
  { name: '₹ 95L', value: 9500000 },
  { name: '₹ 90L', value: 9000000 },
  { name: '₹ 85L', value: 8500000 },
  { name: '₹ 80L', value: 8000000 },
  { name: '₹ 75L', value: 7500000 },
  { name: '₹ 70L', value: 7000000 },
  { name: '₹ 65L', value: 6500000 },
  { name: '₹ 60L', value: 6000000 },
  { name: '₹ 55L', value: 5500000 },
  { name: '₹ 50L', value: 5000000 },
  { name: '₹ 45L', value: 4500000 },
  { name: '₹ 40L', value: 4000000 },
  { name: '₹ 35L', value: 3500000 },
  { name: '₹ 30L', value: 3000000 },
  { name: '₹ 25L', value: 2500000 }
];

export const numberWithCommas = (x: any) => {
  x = x.toString()?.split(".")[0]; // Remove decimal part
  let lastThree = x?.slice(-3);
  let otherNumbers = x?.slice(0, -3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  return otherNumbers?.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;
};

export interface historicalReturn {
  "selectedDate":string,
  "fno_252_return":number,
  "fno_252_aftercost":number,
  "fno_21_return":number,
  "fno_21_aftercost":number,
  "lft_252_return":number,
  "lft_252_aftercost":number,
  "lft_21_return":number,
  "lft_21_aftercost":number,
  "equity_252_return":number,
  "equity_21_return":number,
  "equity_252_aftercost":number,
  "equity_21_aftercost":number,
  "equityN50plus_252_return":number,
  "equityN50plus_21_return":number,
  "equityN50plus_252_aftercost":number,
  "equityN50plus_21_aftercost":number,
  "optLong_252_return":number,
  "optLong_21_return":number,
  "optLong_252_aftercost":number,
  "optLong_21_aftercost":number,
  "252_average_after_cost":number,
  "252_average":number,
  "21_average_after_cost":number,
  "21_average":number,
  "252_start_date":string,
  "21_start_date":string,
  "end_date":string
}

export interface TradesCount {
  "FNO"         :number,
  "LFT"         :number,
  "EQ"          :number,
  "EqN50plus"   :number,
  "OPT_LONG"    :number,
  "EqBANK"      :number,
  "EqIT"        :number,
}

export const getPrivilegeObject: any = async (allCodes: any) => {
  const allModelCodes: any = {
    FNO: [],
    LFT: [],
    EQ: [],
    OPTLONG: [],
  };
  let userPrivilegesCode: any = Cookies.get("codesArray");
  userPrivilegesCode = JSON.parse(userPrivilegesCode);
  allCodes?.map((item: any) => {
    if (item !== null) {
      let code: any = item?.tradeCode;
      if (userPrivilegesCode?.includes(item?.s_code)) {
        allModelCodes[code]?.push({
          ...item,
          value: "subscribed",
          isActive: true,
        });
      } else {
        allModelCodes[code]?.push({
          ...item,
          value: "unsubscribed",
          isActive: false,
        });
      }
    }
  });

  //sorting the arrays
  allModelCodes.FNO = sortByValue(allModelCodes.FNO);
  allModelCodes.LFT = sortByValue(allModelCodes.LFT);
  allModelCodes.EQ = sortByValue(allModelCodes.EQ);
  allModelCodes.OPTLONG = sortByValue(allModelCodes.OPTLONG);
  localStorage.setItem("modelWiseValue", JSON.stringify(allModelCodes));

  return allModelCodes;
};

// Sort function to move 'subscribed' before 'unsubscribed'
export const sortByValue = (array: any) => {
  return array.sort((a: any, b: any) => {
    if (a.value === "subscribed" && b.value === "unsubscribed") {
      return -1;
    } else if (a.value === "unsubscribed" && b.value === "subscribed") {
      return 1;
    } else {
      return 0;
    }
  });
};

export const isLoggedIn = () => {
  let isLoggedIn: any = Cookies.get("details");
  isLoggedIn = JSON.parse(isLoggedIn);

  return isLoggedIn?.isLoggedIn;
};

export default async function pushNotification (msg: any) { 
  if (!("Notification" in window)) {
    console.log("This browser does not support desktop notification");
  } else {
    const access_notification = await Notification.requestPermission()
      if(document.hidden && (Notification.permission == 'granted')){
              const noti = new Notification('New Notification from FEEDSENSE AI', {
                body: `${msg}`,
                icon: 'file:///home/vista-tech-002/Downloads/FEEDSENSE_latest/feedsense_frontend_2024-12-07/feedsense_frontend/public/images/feedsense_ai_icon_new.png',
                requireInteraction: false
              })
              noti.addEventListener("click",(event) =>  { window.open('https://live.feedsense.ai/live') 
              })
              
              }
      }
      return 0
}

export function modelCodeMaking(row:any)
{
  if (row['s_code'].split("-").length > 1){
    return (row?.s_code.split("-")[0]) + row?.s_trade_type[0]?.toUpperCase() +'-'+(row?.s_code.split("-")[1])
  }
  else{
    return row?.s_code + row?.s_trade_type[0]?.toUpperCase()
  }
}


export function accessChecking(row:any)
{
  if (row['s_code'].split("-").length > 1){
    return (row?.s_code.split("-")[0]).slice(0,-1) + '-' + (row?.s_code.split("-")[1])
  }
  else{
    return row?.s_code?.slice(0,-1).toUpperCase()
  }
}


export const isNotificationEnabled=()=>{
  try {
    let isNotificationEnabled:any = '';
    isNotificationEnabled = localStorage.getItem('notificationEnabled');
    isNotificationEnabled = JSON.parse(isNotificationEnabled);
    console.log("isNotified",typeof(isNotificationEnabled),isNotificationEnabled);
    return isNotificationEnabled;
  } catch (error) {
    console.log("Error while getting notification status", error);
    return false;
  }

  

}


// export const csvColumnMap:Record<string, string>={
//   "dt_date":"Open Date",
//   "dt_entry_time":"Entry Time",
//   "dt_close_date":"Close Date",
//   "dt_exit_time":"Exit Time",
//   "dt_expiry_date":"Expiry Date",
//   "j_dividend":"Dividend",
//   "n_exit_price":"Exit Price",
//   "n_pl":"P/L",
//   "n_pl_rs":"P/L (₹)",
//   "n_return":"Return",
//   "n_return_after_cost":"Return After Cost",
//   "n_transaction":"Transaction",
//   "n_strike_price":"Strike Price",
//   "s_code":"Code",
//   "s_option_type":"Option Type",
//   "s_status":"Status",
//   "s_symbol":"Symbol",
//   "s_trade_type":"Trade Type",
//   "j_target_stoploss":"Target_Stoploss_List"

// }

export const csvColumnMap:Record<string, string>={
  "dt_date":"Open Date",
  "dt_entry_time":"Entry Time",
  "dt_close_date":"Close Date",
  "dt_exit_time":"Exit Time",
  "dt_expiry_date":"Expiry Date",
  "j_dividend":"Dividend",
  "n_exit_price":"Exit Price",
  "n_pl":"P/L",
  "n_pl_rs":"P/L (₹)",
  "n_return":"Return",
  "n_return_after_cost":"Return After Cost",
  "n_transaction":"Transaction",
  "n_strike_price":"Strike Price",
  "s_code":"Code",
  "s_option_type":"Option Type",
  "s_status":"Status",
  "s_symbol":"Symbol",
  "s_trade_type":"Trade Type",
  "j_target_stoploss":"Target_Stoploss_List"

}

export const historiCalcsvColumnMap:Record<string, string>={
  "open_date":"Open Date",
  "dt_open_time":"Entry Time",
  "trade_close_date":"Close Date",
  "dt_exit_time":"Exit Time",
  "expiry_date":"Expiry Date",
  "dividend":"Dividend",
  "trade_pl":"P/L",
  "trade_pl_rs":"P/L (₹)",
  "return":"Return",
  "return_ac":"Return After Cost",
  "transaction":"Transaction",
  "strike_price_ce":"Strike Price",
  "identifier":"Code",
  "option_type":"Option Type",
  "close_reason":"Status",
  "asset":"Symbol",
  "tradetype":"Trade Type",
  "j_target_stoploss":"Target_Stoploss_List"

}

export const livePagehistoriCalcsvColumnMap:Record<string, string>={
  "open_date":"Open Date",
  "dt_open_time":"Entry Time",
  "trade_close_date":"Close Date",
  "dt_end_time":"Exit Time",
  "expiry_date":"Expiry Date",
  "j_dividend_list":"Dividend",
  "exit_price":"LTP",
  "trade_pl":"P/L",
  "trade_pl_rs":"P/L (₹)",
  "return_per":"Return",
  "return_after_cost":"Return After Cost",
  "n_open_transaction_price":"Transaction",
  "strike_price_ce":"Strike Price",
  "identifier":"Code",
  "option_type":"Option Type",
  "s_reason":"Status",
  "asset":"Symbol",
  "trade_type":"Trade Type",
  "j_target_stoploss":"Target_Stoploss_List"

}


export const HistocalexportCSV = (selectionOnly: boolean,filteredData:any[]) => {
  const exportData = selectionOnly ? [] : filteredData;
  if (!exportData.length) return;

  const columns = Object.keys(historiCalcsvColumnMap); // use defined field order

  const enrichedData = exportData.map((row: any) => {
    // Flatten or stringify necessary fields
    let j_target_stoploss_arr:any[]
    try {
      j_target_stoploss_arr = row?.j_target_stoploss ? [row?.j_target_stoploss] : [row?.targetStoploss];

    } catch (error) {
      j_target_stoploss_arr = [];
    }
   
    return {
      ...row,
      j_dividend: JSON.stringify(row.j_dividend ?? []),
      j_target_stoploss: JSON.stringify(
        Array.isArray(Object.keys(j_target_stoploss_arr[0]))
          ? Object.keys(j_target_stoploss_arr[0])?.map((item:any) => ({
              time:item ?? '',
              "Target":j_target_stoploss_arr[0][item]["Target"] ?? '',
              "Stoploss":j_target_stoploss_arr[0][item]["Stoploss"] ?? '',
            }))
          : []
      )
    };
  });

  const renamedHeaders = columns.map(key => historiCalcsvColumnMap[key] || key);

  const csvRows = enrichedData.map((row:any) =>
    columns.map((field) => {
      const value = row[field];
      if (typeof value === 'object' && value !== null) {
        return `"${JSON.stringify(value)}"`; // safe stringifying
      }
      return `"${value ?? ''}"`;
    }).join(',')
  );

  const csvContent = [renamedHeaders.join(','), ...csvRows].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const filename = `Historical_Trades.csv`;

  link.setAttribute('href', URL.createObjectURL(blob));
  link.setAttribute('download', filename);
  link.click();
};


export const LivePageHistocalexportCSV = (selectionOnly: boolean,filteredData:any[]) => {
  const exportData = selectionOnly ? [] : filteredData;
  if (!exportData.length) return;

  const columns = Object.keys(livePagehistoriCalcsvColumnMap); // use defined field order

  const enrichedData = exportData.map((row: any) => {
    // Flatten or stringify necessary fields
 
    const j_target_stoploss_arr: any[] = row?.targetStoploss ?  [row?.targetStoploss] : [];
   
    return {
      ...row,
      j_dividend: JSON.stringify(row.j_dividend ?? []),
      j_target_stoploss: JSON.stringify(
        Array.isArray(Object.keys(j_target_stoploss_arr[0]))
          ? Object.keys(j_target_stoploss_arr[0])?.map((item:any) => ({
              time:item ?? '',
              "Target":j_target_stoploss_arr[0][item]["Target"] ?? '',
              "Stoploss":j_target_stoploss_arr[0][item]["Stoploss"] ?? '',
            }))
          : []
      )
    };
  });

  const renamedHeaders = columns.map(key => livePagehistoriCalcsvColumnMap[key] || key);

  const csvRows = enrichedData.map((row:any) =>
    columns.map((field) => {
      const value = row[field];
      if (typeof value === 'object' && value !== null) {
        return `"${JSON.stringify(value)}"`; // safe stringifying
      }
      return `"${value ?? ''}"`;
    }).join(',')
  );

  const csvContent = [renamedHeaders.join(','), ...csvRows].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const filename = `Historical_Trades.csv`;

  link.setAttribute('href', URL.createObjectURL(blob));
  link.setAttribute('download', filename);
  link.click();
};


export const isPrivilegedAndCurrebtDate =(cookiesCodesArr:string,newRow:any,selectedDate:any,current_date:Date):boolean=>{
  if((JSON.parse(cookiesCodesArr)?.includes(accessChecking(newRow))) && (selectedDate === moment(current_date).format("YYYY-MM-DD"))){
    return true;
  }
  else{
    return false;
  }
}


export const monthlyReturnsMapping:Record<string, string> = {
  "s_code"    : "Code",
  "year"      : "Year",
  "s_symbol"  : "Symbol",
  "Jan"       : "January",
  "Feb"       : "February",
  "Mar"       : "March",
  "Apr"       : "April",
  "May"       : "May",
  "Jun"       : "June",
  "Jul"       : "July",
  "Aug"       : "August",
  "Sep"       : "September",
  "Oct"       : "October",
  "Nov"       : "November",
  "Dec"       : "December",
};

export const rollingMapping:Record<string, string> = {
  "dt_date"     : "Date",
  "s_symbol"    : "Symbol",
  "rolling_21"  : "Rolling 21",
  "rolling_65"  : "Rolling 63",
  "rolling_252" : "Rolling 252",
};

export const rollingMappingTableHeader = Object.entries(rollingMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);


export const optionsRollingMapping:Record<string, string> = {
  "dt_start_date" : "Date",
  "s_symbol"      : "Symbol",
  "n_rolling_21"  : "Rolling 21",
  "n_rolling_63"  : "Rolling 63",
  "n_rolling_252" : "Rolling 252",
};

export const optionsRollingMappingTableHeader = Object.entries(optionsRollingMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);

export const monthlyReturnsMappingTableHeader = Object.entries(monthlyReturnsMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);

export const portFolioCriticalMetricMapping: Record<string, string> = {
  "s_symbol"                  : "Symbol",
  "dt_duration"               : "Rolling Duration",
  "n_sharpe_ratio"            : "Sharpe_ratio",
  "n_beta"                    : "Beta",
  "n_jensen_alpha"            : "Jensen_alpha",
  "n_treynor_ratio"           : "Treynor_ratio",
  "n_tracking_error"          : "Tracking_error",
  "n_information_ratio"       : "Information_ratio",
  "n_deflated_sharpe_ratio"   : "Deflated_sharpe_ratio",
  "n_cov"                     : "Co-efficient of Variation",
  "n_modified_var"            : "Modified_var",
  "n_modified_sharpe_ratio"   : "Modified_sharpe_ratio",
  "n_mar"                     : "Mar Ratio",
  "n_sterling_ratio"          : "Sterling_ratio",
  "n_semi_deviation"          : "Semi_deviation",
  "n_sortino_ratio"           : "Sortino_ratio",
  "n_ulcer_index"             : "Ulcer_index",
  "n_calmer_ratio"            : "Calmer_ratio",
  "n_omega_ratio"             : "Omega_ratio",
  "n_kappa_ratio"             : "Kappa_ratio"
};

export const portFolioCriticalMetricMappingTableHeader = Object.entries(portFolioCriticalMetricMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);


export const performanceMetricMapping: Record<string, string> = {
  "s_symbol"              : "Symbol",
  "Total_Trades"          : "Avg Total Trades",
  "Win_Trades"            : "Avg Win Trades",
  "Loss_Trades"           : "Avg Loss Trades",
  "Success"               : "Success (%)",
  "Gross_Profit"          : "Gross Profit",
  "Gross_Loss"            : "Gross Loss",
  "Net_Profit"            : "Net Profit",
  "Return"                : "Return (%)",
  "Return_with_cost"      : "Return (%) with cost",
  "O_to_C_Return"         : "Market Return (%)",
  "Max_Drawdown_Actual"   : "Max Drawdown",
  "Max_Loss"              : "Max Loss",
  "Max_Profit"            : "Max Profit",
  "O_to_C_Point"          : "Market Point",
  "Market_Beat"           : "Market Beat (in Return %)",
  "Profit_Loss_Ratio"     : "Profit/Loss Ratio",
  "Avg_profit_trade"      : "Avg Profit/Trade",
  "Avg_loss_trade"        : "Avg Loss/Trade",
  "Holding_Peroid"        : "Avg Holding Peroid"
};

export const performanceMetricMappingTableHeader = Object.entries(performanceMetricMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);


export const optionsPerformanceMetricMapping: Record<string, string> = {
  "s_symbol": "Symbol",
  "Total_Trade": "Avg Total Trades",
  "Success_Ratio": "Success Ratio",
  "Total_PL": "Total PL",
  "Gross_Profit": "Gross Profit",
  "Gross_Loss": "Gross Loss",
  "PL_ratio": "P/L ratio",
  "Return": "Return (%)",
  "Return_with_cost": "Return (%) with cost",
  "Drawdown": "Drawdown (%)",
  "Positive_Months": "Avg Positive Months",
  "EMR": "EMR"
};

export const optionsPerformanceMetricMappingTableHeader = Object.entries(optionsPerformanceMetricMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);


export const equityPositivePeriodAndMarketBeatMapping: Record<string, string> = {
  "s_symbol": "Symbol",
  "rolling_21": "Monthly(21)",
  "rolling_65": "Quarterly(63)",
  "rolling_252": "Yearly(252)",
  "marketBeat": "Market Beat",
  "score": "Remarks"
};


export const equityPositivePeriodAndMarketBeatMappingTableHeader = Object.entries(equityPositivePeriodAndMarketBeatMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);


export const optionsPositivePeriodAndMarketBeatMapping: Record<string, string> = {
  "s_symbol": "Symbol",
  "rolling_21": "Positive Months",
  "rolling_63": "Positive Quarters",
  "positiveDays": "Positive Days",
  "score": "Remarks"
};


export const optionsPositivePeriodAndMarketBeatMappingTableHeader = Object.entries(optionsPositivePeriodAndMarketBeatMapping).map(
  ([dataIndex, title]) => ({
    title,
    dataIndex,
    key: title,
    width: 120
  })
);


export const generaliseExportCSV = (selectedData: any[], csvColumnHeaderMapping:any,fileName:string) => {


  const exportData = selectedData ? selectedData : [];
  if (!exportData.length) return;

  const columns = Object.keys(csvColumnHeaderMapping); // use defined field order

  // const enrichedData = exportData.map((row: any) => {
  //   // Flatten or stringify necessary fields
  //   return {
  //     ...row,
  //     j_dividend: JSON.stringify(row.j_dividend ?? []),
  //     j_target_stoploss: JSON.stringify(
  //       Array.isArray(row?.j_target_stoploss)
  //         ? row.j_target_stoploss.map((item:any) => ({
  //             time: item?.time || '',
  //             Target: item?.Target ?? '',
  //             Stoploss: item?.Stoploss ?? ''
  //           }))
  //         : []
  //     )
  //   };
  // });

  const renamedHeaders = columns.map(key => csvColumnHeaderMapping[key] || key);

  const csvRows = exportData.map((row:any) =>
    columns.map((field) => {
      const value = row[field];
      if (typeof value === 'object' && value !== null) {
        return `"${JSON.stringify(value)}"`; // safe stringifying
      }
      return `"${value ?? ''}"`;
    }).join(',')
  );

  // console.log("Enrich ",enrichedData);
  //  dispatch(setPreviewTableData(enrichedData))

  const csvContent = [renamedHeaders.join(','), ...csvRows].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  const filename = fileName;

  link.setAttribute('href', URL.createObjectURL(blob));
  link.setAttribute('download', filename);
  link.click();
};